<template>
  <div>
    <h4 class="mt-6 mb-6 ml-6">BRI Offerings</h4>

    <vueper-slides
       class="mr-12 ml-12 mb-4 no-shadow"
      autoplay
      :bullets="false"
      :visible-slides="3"
      :slide-ratio="1/9"
      :dragging-distance="50"
      :breakpoints="{ 800: { visibleSlides: 2 } }"
    >
    <v-icon slot="arrowLeft" style="font-size:3rem;" color="indigo lighten-3" large>mdi-chevron-left</v-icon>
  <v-icon slot="arrowRight" style="font-size:3rem;" color="indigo lighten-3" large>mdi-chevron-right</v-icon>
  
      <vueper-slide v-for="i in slide" :key="i" :image="i"></vueper-slide>
    </vueper-slides>
  </div>
</template>
<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  components: {
    VueperSlides,
    VueperSlide
  },
  data() {
    return {
      slide: [
        "img/1.png",
        "img/2.png",
        "img/3.png",
        "img/4.png",
        "img/5.png",
        "img/6.png",
      ]
    };
  }
};
</script>
<style>
.vueperslide,
.vueperslide__image {
  margin-left: 10px;
  border-radius: 10px !important;
}
.vueperslides__arrow:focus{
  outline: none !important;
}
</style>